export default function updateFirstCalculatorUrl(suggestions) {
    if (!suggestions || suggestions.length === 0) return suggestions;

    const calculatorUrlMap = {
        "Amikacin_initial_dose_calculator#Amikacin_initial_dose_calculator": "/calculator/Amikacin",
        "Gentamicin_initial_dose_calculator#Gentamicin_initial_dose_calculator": "/calculator/Gentamicin",
        "Tobramycin_initial_dose_calculator#Tobramycin_initial_dose_calculator": "/calculator/Tobramycin"
    };

    const firstSuggestion = suggestions[0];

    for (const [key, mappedUrl] of Object.entries(calculatorUrlMap)) {
        if (firstSuggestion.url.includes(key)) {
            let updatedFirst = { ...firstSuggestion, url: mappedUrl };
            if (Array.isArray(firstSuggestion.subTopics)) {
                updatedFirst.subTopics = firstSuggestion.subTopics.map(sub => {
                    if (sub.url && sub.url.includes(key)) {
                        return { ...sub, url: mappedUrl };
                    }
                    return sub;
                });
            }
            return [
                updatedFirst,
                ...suggestions.slice(1)
            ];
        }
    }

    return suggestions;
};